import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import '../styles/Profile.css';
import ApiService from '../ApiService';
import { FaTimes } from 'react-icons/fa';

function Profile({ user, userProfile, setUserProfile, setLanguage}) {
  const { t, i18n } = useTranslation();
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [profileLanguage, setProfileLanguage] = useState(userProfile ? userProfile.language : i18n.language);
  const navigate = useNavigate();

  useEffect(() => {
    if (profileLanguage) {
      i18n.changeLanguage(profileLanguage);
    }
  }, [profileLanguage, i18n]);

  useEffect(() => {
    if (userProfile) {
      setName(userProfile.name);
      setSurname(userProfile.surname);
      setEmail(userProfile.email);
      setPhoneNumber(userProfile.phone_number);
      setLanguage(userProfile.language);
    }
  }, [userProfile, setLanguage]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      userProfile.name = name && name !== '' ? name : null;
      userProfile.surname = surname && surname !== '' ? surname : null;
      userProfile.phone_number = phoneNumber && phoneNumber !== '' ? phoneNumber : null;
      userProfile.email = email && email !== '' ? email : null;
      userProfile.language = profileLanguage;

      const new_user_profile = await ApiService.put('/user/', userProfile, user)
      setUserProfile(new_user_profile);
      navigate('/homepage');

    } catch (error) {
      console.error('Error updating profile:', error);
      alert(t('profile.alert_fail'));
    }
  };

  const handleClose = () => {
    navigate('/homepage');
  };

  return (
    <div className="profile-container">
      <div className="bottom-section profile-view">
        <button className="profile-close" onClick={handleClose}>
          <FaTimes />
        </button>
        <div className="profile-form-container">
          <h1>{t('profile.title')}</h1>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">{t('profile.name')}</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="surname">{t('profile.surname')}</label>
              <input
                type="text"
                id="surname"
                value={surname}
                onChange={(e) => setSurname(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">{t('profile.email')}</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">{t('profile.phone_number')}</label>
              <input
                type="tel"
                id="phone"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="language">{t('profile.preferred_language')}</label>
              <select
                id="language"
                value={profileLanguage}
                onChange={(e) => {setProfileLanguage(e.target.value); setLanguage(e.target.value);} }
              >
                <option value="en">English</option>
                <option value="pl">Polish</option>
                <option value="fr">French</option>
                <option value="es">Spanish</option>
                <option value="zh">Chinese</option>
                <option value="uk">Ukrainian</option>
              </select>
            </div>
            <button type="submit" className="save-button">{t('profile.save')}</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Profile;
